import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { customerAuthAPi } from "./actions/Customer/authCustomer";
import rootReducer from "./rootReducer";
import { adminAuthAPi } from "./actions/Admin/authAdmin";
import { customerProfileAPi } from "./actions/Customer/profileCustomer";
import { adminServiceAPi } from "./actions/Admin/ServiceAdmin";
import { adminPetsAPi } from "./actions/Admin/PetsAdmin";
import { adminDashboardAPi } from "./actions/Admin/dashboardAdmin";
import { serviceCustomerAPi } from "./actions/Customer/serviceCustomer";
import { adminProductAPi } from "./actions/Admin/ProductAdmin";
import { footerManagementAdminAPi } from "./actions/Admin/footerManagementAdmin";
import { customerFooterAPi } from "./actions/Customer/FooterCustomer";
import { customerCartAPi } from "./actions/Customer/cartCustomer";
import { adminOrderAPi } from "./actions/Admin/orderAdmin";
import { adminAbandonedCartAPi } from "./actions/Admin/abandonedCartAdmin";
import { analyticsApi } from "./actions/Admin/AnalyticsApi";
import { customerAnalyticsApi } from "./actions/Customer/analyticsCustomer";
const persistConfig = {
  key: "root",
  storage,
  blacklist: [], // Add reducers which not require to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
      .concat(customerAuthAPi.middleware)
      .concat(customerProfileAPi.middleware)
      .concat(adminAuthAPi.middleware)
      .concat(adminServiceAPi.middleware)
      .concat(adminPetsAPi.middleware)
      .concat(adminDashboardAPi.middleware)
      .concat(serviceCustomerAPi.middleware)
      .concat(adminProductAPi.middleware)
      .concat(customerFooterAPi.middleware)
      .concat(footerManagementAdminAPi.middleware)
      .concat(adminOrderAPi.middleware)
      .concat(adminAbandonedCartAPi.middleware)
      .concat(analyticsApi.middleware)
      .concat(customerCartAPi.middleware)
      .concat(customerAnalyticsApi.middleware),
  devTools: true,
});
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
